const updateButtonAvailability = () => {
  const availableDates = document.querySelectorAll('.daterangepicker th.available:not(.off), .daterangepicker td.available');
  availableDates.forEach((el) => {
    el.setAttribute('tabIndex', '0');
  });
  const unavailableDates = document.querySelectorAll('.daterangepicker td.available.close');
  unavailableDates.forEach((el) => {
    el.setAttribute('ariaDisabled', 'true');
    el.classList.add('disabled');
    el.classList.remove('available');
  });
};

const focusNextElement = () => {
  const widgetEl = document.querySelector('.booking-widget');
  const focussableElements = widgetEl.querySelectorAll('button:not([tabindex^="-"]), select:not([tabindex^="-"]), [tabindex]:not([tabindex="option"]):not([tabindex^="-"])');
  // find index date/daterange picker
  const index = Array.from(focussableElements).indexOf(widgetEl.querySelector('.booking-widget__date')
    || widgetEl.querySelector('.booking-widget__daterange'));

  const nextElement = focussableElements[index + 1]
    || focussableElements[focussableElements.length - 1];
  nextElement.focus();
};

// eslint-disable-next-line prefer-arrow-callback
// eslint-disable-next-line wrap-iife
(function ($) {
  $(document).ready(() => {
    let toggleDatesSelection = false;
    let startDate = -1;

    const isSingle = () => $('.booking-widget__daterange').length < 1;

    const setFocus = (triggerSelector) => {
      const trigger = $(triggerSelector);
      $(trigger.get(0)).trigger('focus');
    };

    $(document).on('click', 'th.next.available, th.next.available span, h.prev.available, th.prev.available span', updateButtonAvailability);

    $('body').on('keydown', '.booking-widget__daterange', (e) => {
      if ([13, 32].includes(e.which)) {
        toggleDatesSelection = false;
      }
    });

    $('body').on('keydown', '.applyBtn', (e) => {
      if (e.which === 27) {
        $('.daterangepicker .cancelBtn').trigger('click');
      }

      if (e.which === 13) {
        $('.daterangepicker .applyBtn').trigger('click');
      }

      if (!e.shiftKey && e.which === 9) {
        e.preventDefault();
        const prev = $('th.prev.available');
        const next = $('th.next.available');

        if (prev.length) {
          prev.attr('tabindex', 2);
          prev.focus();
        } else {
          next.attr('tabindex', 2);
          next.focus();
        }
      }

      if (e.shiftKey && e.which === 9) {
        e.preventDefault();
        setFocus('.daterangepicker .cancelBtn');
      }

      return false;
    });

    $('body').on('click', '.applyBtn, .cancelBtn', () => {
      focusNextElement();
    });

    $('body').on('keydown', '.cancelBtn', (e) => {
      e.preventDefault();

      if ([27, 13].includes(e.which)) {
        $('.daterangepicker .cancelBtn').trigger('click');
      }

      if (e.shiftKey && e.which === 9) {
        e.preventDefault();
        setTimeout(() => {
          if (toggleDatesSelection || isSingle()) {
            const sDate = $('.daterangepicker td.start-date');
            setFocus(sDate.length ? '.daterangepicker td.start-date' : '.daterangepicker td.available:not(.off)');
          } else {
            setFocus('.daterangepicker td.available:not(.off)');
          }
          return false;
        });
      }

      if (!e.shiftKey && e.which === 9) {
        e.preventDefault();
        if (!toggleDatesSelection || isSingle()) {
          setTimeout(() => {
            setFocus('.daterangepicker .applyBtn');
          });
        } else {
          setTimeout(() => {
            const prev = $('.daterangepicker th.prev.available');
            const next = $('.daterangepicker th.next.available');

            if (prev.length) {
              $(prev.get(0)).focus();
            } else {
              $(next.get(0)).focus();
            }
            return false;
          });
        }
      }
    });

    $('body').on('keydown', 'th.next.available', function (e) {
      e.preventDefault();
      if (e.which === 27) {
        $('.daterangepicker .cancelBtn').trigger('click');
      }

      if (e.which === 13) {
        $(this).trigger('click.daterangepicker');
        setTimeout(() => {
          updateButtonAvailability();
          setFocus('.daterangepicker th.available.next');
          return false;
        });
      }

      if (!e.shiftKey && e.which === 9) {
        if (toggleDatesSelection || isSingle()) {
          const sDate = $('.daterangepicker td.start-date');
          setFocus(sDate.length ? '.daterangepicker td.start-date' : '.daterangepicker td.available:not(.off)');
        } else {
          setFocus('.daterangepicker td.available:not(.off)');
        }
      }
      if (e.shiftKey && e.which === 9) {
        const prev = $('.daterangepicker th.prev.available');
        if (prev.length) {
          setTimeout(() => {
            prev.trigger('focus');
          });
        } else {
          setTimeout(() => {
            setFocus(!toggleDatesSelection || isSingle() ? '.daterangepicker .applyBtn' : '.daterangepicker .cancelBtn');
          });
        }
      }
    });

    $('body').on('keydown', 'th.prev.available', function (e) {
      if (e.which === 27) {
        $('.daterangepicker .cancelBtn').trigger('click');
      }

      if (e.which === 13) {
        e.preventDefault();
        $(this).trigger('click.daterangepicker');
        setTimeout(() => {
          const prev = $('th.prev.available');

          updateButtonAvailability();
          if (prev.length) {
            prev.focus();
          } else {
            setFocus($('.daterangepicker td.today:not(.close)').length ? '.daterangepicker td.today' : 'th.next.available');
          }
          return false;
        });
      }

      if (e.shiftKey && e.which === 9) {
        e.preventDefault();
        setFocus('.daterangepicker .applyBtn');
      }
      if (!e.shiftKey && e.which === 9) {
        setFocus('.daterangepicker th.next.available');
      }

      return false;
    });

    $('body').on('keydown', '.daterangepicker td.available, .daterangepicker td.disabled', function (e) {
      if (e.which === 27) {
        $('.daterangepicker .cancelBtn').trigger('click');
        return false;
      }

      const dataTitle = $(this).data('title');
      const row = +dataTitle.substr(1, 1);
      const column = +dataTitle.substr(3, 1);
      let newRow = row;
      let newColumn = column;

      let navigateTo = '';

      const isLeft = $(this).closest('.drp-calendar').hasClass('left');

      if (!e.shiftKey && e.which === 9) {
        setFocus('.daterangepicker .cancelBtn');
        return false;
      }
      if (e.shiftKey && e.which === 9) {
        setFocus('.daterangepicker th.available.next');
        return false;
      }

      switch (true) {
        case (e.which === 13 || e.which === 32): { // enter/space
          if ($(this).hasClass('disabled')) break;

          $(this).trigger('mousedown.daterangepicker');

          const month = $(this).closest('.table-condensed').find('.month').html();
          const newDate = new Date(`${$(this).html()} ${month}`);

          if (startDate === -1 || startDate > newDate.getTime()) {
            toggleDatesSelection = true;
            startDate = newDate.getTime();
          } else {
            toggleDatesSelection = false;
            startDate = -1;
          }

          setTimeout(() => {
            if (isSingle()) {
              e.preventDefault();
              setTimeout(() => {
                e.preventDefault();
                setTimeout(() => {
                  $('.daterangepicker .applyBtn').trigger('focus');
                });
              });
              return;
            }

            updateButtonAvailability();
            if (
              ($('.daterangepicker td.available.start-date').length && !$('.daterangepicker td.available.end-date').length)
            ) {
              $('.daterangepicker td.active').focus();
            } else {
              $('.daterangepicker .applyBtn').focus();
            }
          });
          break;
        }
        case e.which === 37: { // left
          if (column > 0) {
            newColumn = column - 1;
          } else if (row > 0) {
            newRow = row - 1;
            newColumn = 6;
          } else if (isLeft || isSingle()) {
            newRow = -1;
            newColumn = -1;
            navigateTo = 'prev';
          } else {
            navigateTo = 'prevMonth';
            newRow = 5;
            newColumn = 6;
          }
          break;
        }
        case e.which === 38: { // up
          if (row > 0) {
            newRow = row - 1;
          } else if (isLeft || isSingle()) {
            navigateTo = 'prev';
          } else {
            navigateTo = 'prevMonth';
            newRow = 5;
          }
          break;
        }
        case e.which === 39: { // right
          if (column < 6) {
            newColumn = column + 1;
          } else if (row < 5) {
            newColumn = 0;
            newRow = row + 1;
          } else if (isLeft) {
            navigateTo = isSingle() ? 'next' : 'nextMonth';
            newColumn = 0;
            newRow = 0;
          } else {
            navigateTo = 'next';
          }
          break;
        }
        case e.which === 40: { // down
          if (row < 5) {
            newRow = row + 1;
          } else if (isLeft) {
            navigateTo = 'nextMonth';
            newRow = 0;
          } else {
            navigateTo = 'next';
            if (isSingle()) {
              newRow = 0;
            }
          }
          break;
        }
        default:
          break; // exit this handler for other keys
      }
      e.preventDefault(); // prevent the default action (scroll / move caret)
      switch (navigateTo) {
        case '':
          $(this).closest('tbody').find(`[data-title=r${newRow}c${newColumn}]`).focus();
          break;
        case 'prev':
          $('.daterangepicker .prev').focus();
          break;
        case 'next':
          $('.daterangepicker .next').focus();
          break;
        case 'nextMonth':
          $(this).closest('.daterangepicker')
            .find('.drp-calendar.right')
            .find(`[data-title=r${newRow}c${newColumn}]`)
            .focus();
          break;
        case 'prevMonth':
          $(this).closest('.daterangepicker')
            .find('.drp-calendar.left')
            .find(`[data-title=r${newRow}c${newColumn}]`)
            .focus();
          break;
        case 'cancel':
          $('.daterangepicker .cancelBtn').focus();
          break;
        default:
          break; // exit this handler for other keys
      }

      return false;
    });
  });
})(jQuery); // eslint-disable-line

export { updateButtonAvailability };
